import { graphql } from '~/graphql/generated/gql';

export const earnedAwardFragment = graphql(`
  fragment EarnedAwardFields on UserEarnedAward {
    id
    awardType
    awardId
    award {
      ... on Badge {
        id
        name
        tier
        partner {
          ...PartnerReferenceFields
        }
        iconFile {
          ...PublicFileFields
        }
        premiumBadgeFile {
          ...PublicFileFields
        }
        meta {
          disclaimer
        }
        awardedToMyselfCount
      }
      ... on Skill {
        id
        name
        slug
        iconFile {
          ...PublicFileFields
        }
        awardedToMyselfCount
      }
    }
    createdAt
  }
`);

export const awardWalletBadgeListFragment = graphql(`
  fragment AwardWalletBadgeListFields on Badge {
    id
    name
    tier
    slug
    partner {
      ...PartnerReferenceFields
    }
    iconFile {
      ...PublicFileFields
    }
    coverImage {
      ...PublicFileFields
    }
    awardedToMyselfCount
  }
`);

export const awardWalletBadgeDetailFragment = graphql(`
  fragment AwardWalletBadgeDetailFields on Badge {
    id
    name
    tier
    slug
    iconFileId
    coverImageId
    partner {
      ...PartnerReferenceFields
    }
    createdAt
    iconFile {
      ...PublicFileFields
    }
    coverImage {
      ...PublicFileFields
    }
    premiumBadgeFile {
      ...PublicFileFields
    }
    learningAssetCollections {
      id
      name
      slug
      logoImage {
        ...PublicFileFields
      }
      learningAssets {
        id
        name
        coinValue {
          ...CoinValueFields
        }
        publishedSkills {
          id
          name
          slug
        }
        currentUserProgress {
          id
          completedAt
        }
      }
      activeCampaign {
        id
        name
        hasPrize
      }
      spotlight {
        ...SpotlightFields
      }
    }
    awardedToMyselfCount
    meta {
      ...BadgeMetaFields
    }
    publishedAt
  }
`);

export const awardWalletBadges = graphql(`
  query awardWalletBadges($page: Int!, $first: Int!, $filters: BadgeFilters) {
    badges(page: $page, first: $first, filters: $filters) { 
      data {
        ...AwardWalletBadgeListFields 
      }
      paginatorInfo {
        ...PaginatorInfoFields
      }
    }
  }
`);

export const awardWalletBadgeDetail = graphql(`
  query awardWalletBadgeDetail($filters: BadgeFilters) {
    badges(page: 1, first: 1, filters: $filters) {
      data {
        ...AwardWalletBadgeDetailFields
      }
      paginatorInfo {
        ...PaginatorInfoFields
      }
    }
  }
`);

export const awardWalletSkills = graphql(`
  query awardWalletSkills($page: Int!, $first: Int!, $filters: SkillFilters) {
    skills(page: $page, first: $first, filters: $filters) {
      data {
        ...SkillFields
        awardedToMyselfCount
      }
      paginatorInfo {
        ...PaginatorInfoFields
      }
    }
  }
`);

export const fetchLearnBadges = graphql(`
  query fetchLearnBadges($first: Int!) {
    badges(
      page: 1
      first: $first
      filters: { tiers: [PREMIUM], hasPublicCollection: true }
      orderBy: [{ column: PUBLISHED_AT, order: DESC }]
    ) {
      data {
        id
        name
        slug
        partner {
          id
          name
          iconFile {
            publicUrl
          }
        }
        iconFile {
          publicUrl
        }
        coverImage {
          publicUrl
        }
      }
    }
  }
`);
